import { ActionType } from 'typesafe-actions';

import NewsPage, { NewsItem } from '@interfaces/news-page';

import * as types from './types';
import * as actions from './actions';

export type NewsAction = ActionType<typeof actions>;

export interface NewsState {
    readonly list: NewsPage;
    readonly one: Partial<NewsItem>;
    readonly isLoading: boolean;
    readonly error?: string | boolean;
}

const initialState: NewsState = {
    list: { rows: [], meta: {} },
    one: {},
    isLoading: false,
    error: undefined
};

/* tslint:disable-next-line */
function reducer(state: NewsState = initialState, action: NewsAction): NewsState {
    switch (action.type) {
        case types.FETCH_NEWS_PAGE:
            return fetchNewsPage(state);

        case types.FETCH_NEWS_PAGE_SUCCESS:
            return fetchNewsPageSuccess(state, action);

        case types.FETCH_NEWS_PAGE_ERROR:
            return fetchNewsPageError(state, action);

        case types.FETCH_NEWS:
            return fetchNews(state);

        case types.FETCH_NEWS_SUCCESS:
            return fetchNewsSuccess(state, action);

        case types.FETCH_NEWS_ERROR:
            return fetchNewsError(state, action);

        default:
            return state;
    }
}

function fetchNewsPage(state: NewsState) {
    return {
        ...state,
        isLoading: true,
        error: false
    };
}

function fetchNewsPageSuccess(state: NewsState, action: any) {
    const { meta, rows } = action.payload;

    return {
        ...state,
        list: {
            meta,
            rows: [...state.list.rows, ...rows]
        },
        isLoading: false,
        error: false
    };
}

function fetchNewsPageError(state: NewsState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

function fetchNews(state: NewsState) {
    return {
        ...state,
        one: {},
        isLoading: true,
        error: false
    };
}

function fetchNewsSuccess(state: NewsState, action: any) {
    return {
        ...state,
        one: action.payload,
        isLoading: false,
        error: false
    };
}

function fetchNewsError(state: NewsState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

export default reducer;
